"use client"

import { Briefcase } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BriefcaseIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BriefcaseIcon = component(Icon)({ as: Briefcase })
